"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.czechRepublicTranslations = void 0;
var _types = require("../../../types");
const czechRepublicTranslations = exports.czechRepublicTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Moc se omlouváme!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Zpět',
  [_types.ErrorPageTranslationKey.text]: 'Tato stránka je dočasně mimo provoz',
  [_types.ErrorPageTranslationKey.notFound]: 'Stránka, kterou jste chtěli zobrazit není dostupná',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Stránka, kterou se snažíte dostat je omezena a vy nesplňujete kritéria pro její zobrazení.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Kontaktujte prosím tým podpory Oriflame e-mailem:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Požadovaná adresa URL byla zamítnuta!'
};
